
<template>
	<div>
		<div class="text-right">
			<v-btn  text @click="downloadInvoice" >
				<v-icon color="#6D7C8E" small> mdi-printer</v-icon>
				<span class="secodry-text-2">{{$lang.PRINT}}</span>
				<!-- <v-icon color="#6D7C8E"> mdi-printer</v-icon>
					{{$lang.PRINT}} -->
				</v-btn>
			</div>

			<div>
				<detail-block :shipment_details="shipment_details"/>
			</div>
			<!-- returned shipment list -->
			<div>
				<v-row class="">
					<v-col md="6" >
						<span class="page-title ">
							{{$lang.SHIPMENTS.toUpperCase()}} | {{shipment_list.length}}
						</span>
					</v-col>
				</v-row>

				<div class="my-2">
					<div class="filter-btn status-text-filter px-4 py-1 mx-2 cursor-pointer"  v-for="(item,i) in filter_status_options" :key="i"  @click="applyFilter(item.value)" :class="filter_status==item.value?'elevation-1 border-rounded':'elevation-0'" >
						{{item.text}}
						<v-icon v-if="i>0" size="10" style="margin-top:-3px;" class="pl-2" :color="getColorCode(item.value)" >
							mdi-checkbox-blank-circle
						</v-icon>
					</div>

				</div>

				<v-data-table
				:headers="headers"
				:items="shipment_list"
				:hide-default-footer="true"
				:disable-sort="true"
				class="elevation-1 custome-header-bg custome-table-body"
				:loading="table_loading"
				>

				<template v-slot:item.retailer_firm_name="{ item }">
					<p>{{item.retailer_firm_name}}</p>
					<p>{{$lang.MOBILE_PREFIX}}{{item.retailer_mobile_number}}</p>
				</template>	
				<template v-slot:item.shipment_amount="{ item }">
					<p v-if="item.final_status==$keys.RETURN ||item.final_status==$keys.PARTIAL_RETURN">0.00</p>
					<p v-else >{{item.shipment_amount}}</p>
				</template>	
				
				<template v-slot:item.action="{ item }">
					<v-btn small fab text @click="$router.push({name:'shipment-details',params:{shipment_id:encript(item.shipment_id)}})">	
						<img src="../../assets/arrow-right.svg" alt="">	
					</v-btn>	
				</template>	
				<template v-slot:item.shipment_status="{ item }">
					<span  :class="getClassSatus(item.shipment_status)">{{item.shipment_status}}</span>
				</template>	
			</v-data-table>

		</div>
	</div>
</template>
<script type="text/javascript">
export default {
	components:{
		DetailBlock:()=>import('./child/DetailBlock.vue')
	},
	data(){
		return{

			transaction_id:"",
			shipment_details:{
				amount:"",
				received_on:"-",
				recipient_name:"",
				shipment_count:"",
				transaction_id:"",
				transaction_otp:"",
				type:"",
			},

			copy_shipment_list:[],
			shipment_list:[],
			table_loading:false,
			headers: [
			{
				text: 'Shipment ID',
				align: 'start',
				sortable: false,
				value: 'shipment_id',
			},
			{ text: 'Retailer Info', value: 'retailer_firm_name' },
			{ text: 'Challan', value: 'challan_number' },
			{ text: 'Amount', value: 'shipment_amount' },
			{ text: 'Type', value: 'final_status' },
			{ text: 'Status', value: 'shipment_status' },
			{ text: '', value: 'action' },
			],
			/* for filter in web end */ 
			filter_status:null,
			filter_status_options:[
			{text:'All',is_active:true,value:null},
			{text:'Collected',is_active:false,value:"Collected"},
			{text:'Return',is_active:false,value:"Return"},
			{text:'Partial Return',is_active:false,value:"Partial Return"}
			],

		}
	},
	created(){

		this.$store.dispatch('drawer/setActiveTab','withdrawal')
		if(this.$store.state.user_type==this.$keys.WHOLESALER)
			this.$store.dispatch('drawer/setActiveTab','wallet')

		if (this.$route.params.transaction_id){
			this.transaction_id= this.decrypt(this.$route.params.transaction_id)
			this.getWithdrawalDetails()
		}
		

	},

	methods:{
		getWithdrawalDetails() {
			const self=this
			let params={
				id:this.transaction_id,
			};
			self.table_loading=true

			const successHandler = (response) => {
				if (response.data.success){
					self.shipment_details.amount=response.data.amount;
					self.shipment_details.recipient_name=response.data.recipient_name;
					self.shipment_details.shipment_count=response.data.shipment_count;
					self.shipment_details.transaction_id=response.data.transaction_id;
					self.shipment_details.transaction_otp=response.data.transaction_otp;
					self.shipment_details.received_on=response.data.received_on;
					self.shipment_details.type=response.data.type;
					self.shipment_details.returned_count=response.data.returned_count;

					let collection_list=response.data.collection_list
					let return_list=response.data.return_list
					/* adding extra keys for the  for collection  and Returns */
				/*	collection_list.map(function(entry) {
						entry.type = 'Collection';
						return entry;
					});
					return_list.map(function(entry) {
						entry.type = "Returns";
						return entry;
					});
					*/
					self.shipment_list=collection_list.concat(return_list)
					self.copy_shipment_list=collection_list.concat(return_list)

				}
			};
			const finallyHandler = () => {
				self.table_loading=false
				this.$store.dispatch('setPageLoader', false)
			};

			self.request_GET( self,self.$urls.WITHDRAW_DETAILS,params,successHandler,null,null,finallyHandler)
		},
		/* filter for thr collection return partial return  */
		applyFilter(status){
			console.log(status)
			
			this.shipment_list=this.copy_shipment_list

			this.filter_status=status
			if (status){
				this.shipment_list=this.shipment_list.filter(function(item) {
					return item.final_status==status;

				});
			}


		},
		getColorCode(status){
			if (status=="Collected")
				return "#2D9CDB"
			if (status=="Return")
				return "#EB5757"
			if (status=="Partial Return")
				return "#E9BE00"
		},
		downloadInvoice(){
			const self=this
			const reqListener = () => {
				if(xhr.status==200){
					var arrayBuffer = xhr.response;
					var fileURL = URL.createObjectURL(xhr.response);
					window.open(fileURL);
				}
			};

			let url =this.$urls.BASE_URL+"shipment/withdraw/get-pdf/?id="+self.transaction_id
			console.log(url)
			var xhr = new XMLHttpRequest();
			xhr.addEventListener("load", reqListener);
			xhr.open("GET", url); 
			xhr.responseType="blob"; 
			xhr.overrideMimeType("application/pdf; charset=x-user-defined");
			xhr.send(); 
			console.log(xhr)
		},
	}
}
</script>